module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/list-item/list-item.component.scss
// module id = ./src/app/list-item/list-item.component.scss
// module chunks = main